<div class="mt-1 text-center">
    <p class="text-muted">Powered By 
        <span class="custom-primary" style="font-weight: 500;">Zea</span>
        <span class="custom-black" style="font-weight: 500;">Med</span>
    </p>
</div>